var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBbqArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.26702 3.5C8.62578 3.90909 8.30516 4.72727 8.62578 5.34091C8.98237 6.02339 9.58764 6.36364 9.58764 6.97727C9.58764 7.49474 9.05327 7.86364 8.9464 8M12.4732 3.5C11.832 3.90909 11.5113 4.72727 11.832 5.34091C12.1886 6.02339 12.7938 6.36364 12.7938 6.97727C12.7938 7.49474 12.2595 7.86364 12.1526 8M15.6794 3.5C15.0381 3.90909 14.7175 4.72727 15.0381 5.34091C15.3947 6.02339 16 6.36364 16 6.97727C16 7.49474 15.4656 7.86364 15.3588 8",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 11.1364H18.2971M18.2971 11.1364V11.1364C18.4283 10.5243 17.9253 10 17.2994 10H8.12831C6.97489 10 6.05469 10.99 6.45532 12.0716C6.9965 13.5327 8.06986 15.0903 9.97788 15.7975M18.2971 11.1364C17.9258 12.8693 16.8227 15.0859 14.3407 15.8838M14.3407 15.8838C13.7401 16.0769 13.0588 16.1869 12.2876 16.1869C11.408 16.1869 10.6423 16.0437 9.97788 15.7975M14.3407 15.8838L15.8805 20.2273M15.8805 20.2273C16.9071 20.101 17.292 20.7323 17.292 21.2374C17.292 21.7424 16.96 22.2475 16.2655 22.2475C15.6496 22.2475 15.2389 21.7424 15.2389 21.2374M15.8805 20.2273C15.3673 20.4798 15.2389 20.8586 15.2389 21.2374M9.97788 15.7975L8.10325 21.2374M7.66814 22.5L8.10325 21.2374M8.10325 21.2374H15.2389",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbqArea);
export default __webpack_public_path__ + "static/media/bbq_area.2943aee89637ff19b445d0b0409c05d5.svg";
export { ForwardRef as ReactComponent };